import { TaxCountryConfig, TaxIDType } from "../../models/tax.model";

/** State for tax objects */
export interface TaxState {
    taxIdTypes: TaxIDType[],
    taxCountries: TaxCountryConfig[],
}

export const initialState: TaxState = {
    taxIdTypes: [],
    taxCountries: [],
};